<template>
    <div class="rating-board-container">
        <Title :strong="2">
            评分
            <a-button class="rating-helper" type="link" @click="ratingHelp">
                <a-icon type="question-circle" />分数说明
            </a-button>
        </Title>
        <div class="rating-board-content">
            <div class="ratings">
                <rating title="制作精美程度" class="design-rating"
                    scoreColor="#494949"
                    :rating="stat.designrating"
                    :labels="designLabels"
                    :formula="formula"
                />
                <rating title="最低通关难度" class="difficulty-rating"
                    :scoreColor="calDifficultyColor"
                    :rating="stat.difficultyrating"
                    :labels="difficultyLabels"
                    :formula="formula"
                />
            </div>
            <div class="myrate" v-if="myrate">
                <div>
                    制作精美程度:
                    <a-rate
                        :value="designRate"
                        @change="(v) => rate('design', v)"
                        :tooltips="designLabels"
                    ></a-rate>
                    <span class="ant-rate-text">{{ designRate ? designLabels[designRate - 1] : '' }}</span>
                </div>
                <div>
                    最低通关难度:
                    <a-rate class="difficulty-rate"
                        :value="Number(myrate.difficultyRate)"
                        @change="(v) => rate('difficulty', v)"
                        :tooltips="difficultyLabels"
                        character="■"
                    ></a-rate>
                    <span class="ant-rate-text">{{ designRate ? difficultyLabels[difficultyRate - 1] : '' }}</span>
                </div>
            </div>
            <div v-else class="myrate-error">
                通关此塔才能评分
            </div>
            <h3>颜色投票</h3>
            <div>
                <div>
                    <span class="colorrate-count">当前已有 {{ colorrate[2] }} 人投票</span>
                </div>
                <div v-if="colorrate[0] > 0">
                    <span>
                        你不满足颜色投票的资格
                        <a-button class="colorrate-helper" size="small" type="link" @click="toggleDetail">
                            <span v-if="!showDetail"><a-icon type="question-circle" />显示详情</span>
                            <span v-else>隐藏详情</span>
                        </a-button>
                    </span>
                    <ul v-show="showDetail" class="qualification-check">
                        <li v-for="step in 4" :key="step" :class="{ passed: colorrate[0] < step }">
                            <a-icon v-if="colorrate[0] > step"
                                class="success" type="check-circle" theme="filled"
                            />
                            <a-icon v-else-if="colorrate[0] == step"
                                class="error" type="close-circle" theme="filled"
                            />
                            <!-- <a-icon v-else-if="colorrate[0] < step"
                                class="passed" type="minus-circle" theme="filled"
                            /> -->
                            <span :class="{ error: step == colorrate[0] }">
                                {{ checkList[step-1].text }}
                            </span>
                            <br v-if="step == colorrate[0]" />
                            <span v-if="step == colorrate[0]" class="detail"
                                v-html="checkList[step-1].detail(colorrate[1])"
                            ></span>
                        </li>
                    </ul>
                </div>
                <div v-else>
                    <a-radio-group v-model="nowcolor">
                        <a-radio-button 
                            v-for="(color, index) of colors" :key="index"
                            :value="index" :style="{ background: color.value }"
                        >
                            {{ color.name }}
                        </a-radio-button>
                    </a-radio-group>
                    <a-button class="colorrate-update" :loading="onDoColorRate"
                        :disabled="nowcolor < 0 || nowcolor == colorrate[1]"
                        @click="doColorRate(nowcolor)"
                    >更新</a-button>
                    <a-button class="colorrate-withdraw" :loading="onDoColorRate"
                        :disabled="colorrate[1] < 0"
                        @click="doColorRate(-1)"
                    >撤回打分</a-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Rating from '../components/Rating.vue';
import { default as ARate } from 'ant-design-vue/es/rate';
import axios from 'axios';
import { createFormData } from '../../../utils/utils';
import Title from '@/components/Title.vue';
import { COLORS } from '../../../constant';

export default {
    props: {
        stat: Object,
        myrate: Object,
        colorrate: Array,
    },
    data: () => ({
        designLabels: ['极差', '较差', '一般', '较好', '极好'],
        difficultyLabels: ['极易', '较易', '一般', '较难', '极难'],
        onRating: false,
        checkList: [
            { text: '用户需要绑定qq', detail: () => /* HTML */
                `<a href="https://h5mota.com/bbs/thread/?tid=355&p=1" target="_blank">如何绑定?</a>`
            },
            { text: '用户创建账号时间需要超过一个月', detail: (val) => `您的账号已创建了${ val }天` },
            { text: '用户通关10座蓝绿区的塔', detail: (val) => `您已经通关了${ val }座塔` },
            { text: '用户通关本塔或游玩本塔超过30分钟', detail: (val) => `您已经游玩了${ val }分钟` },
        ],
        showDetail: false,
        colors: COLORS,
        onDoColorRate: false,
        nowcolor: -1,
    }),
    inject: [ 'app' ],
    computed: {
        designRate() {
            return Number(this.myrate.designRate);
        },
        difficultyRate() {
            return Number(this.myrate.difficultyRate);
        },
    },
    created() {
        this.nowcolor = this.colorrate[1];
    },
    methods: {
        calDifficultyColor(score) {
            return `rgb(${255*(score-1)/5 },${255*(5-score)/4}, 33)`;
        },
        /**
         * @param {number[]} stat
         */
        formula(stat) {
            const count = stat.reduce((sum, e) => sum + e, 0);
            if (count < 10) {
                return "---";
            }
            const removecnt = Math.floor(count / 10 + 1);
            const _stat = stat.concat();
            for (let i = 0, removemin = removecnt; i < 5; i++) {
                while (removemin > 0) {
                    if (_stat[i] > 0) {
                        _stat[i]--;
                        removemin--;
                    } else {
                        break;
                    }
                }
            }
            for (let i = 4, removemax = removecnt; i > -1; i--) {
                while (removemax > 0) {
                    if (_stat[i] > 0) {
                        _stat[i]--;
                        removemax--;
                    } else {
                        break;
                    }
                }
            }
            const _count = count - 2 * removecnt;
            const sum = _stat.reduce((sum, e, i) => sum + e * (i+1), 0);
            return (sum / _count).toFixed(2);
        },
        async rate(type, value) {
            try {
                const name = this.app.tower.name;
                this.onRating = true;
                const { data } = await axios
                    .post("/backend/tower/rateOld.php", createFormData({
                        name, type, value
                    }));
                if (data.code == 0) {
                    this.$message.success(`投票成功`);
                    this.app.rating.stat = data.rating;
                    this.app.rating.myrate = data.myrate;
                }
            } catch (e) {
                this.$message.error(`投票失败: ${ e }`);
            } finally {
                this.onRating = false;
            }
        },
        ratingHelp() {
            this.$info({
                title: '分数说明',
                content: h => (
                    <div class="help-text">
                        <p><a-tag>制作精美程度</a-tag>代表你觉得这塔制作的多么优秀。</p>
                        <p>
                            <a-tag>最低通关难度</a-tag>仅作为面向没玩过该塔的玩家的通关难度参照。<br/>
                            分数越高，说明这塔（最低难度下）越难以通关，越不适合新人进行游戏。
                        </p>
                        <p>平均分计算时, 会去掉(10%+1)最高分和(10%+1)最低分</p>
                        <p>少于10人评分时不显示分数</p>
                    </div>
                ),
            });
        },
        toggleDetail() {
            this.showDetail = !this.showDetail;
        },
        async doColorRate(value) {
            this.onDoColorRate = true;
            try {
                const { data } = await axios
                    .post("/backend/tower/rate.php", createFormData({
                        name: this.app.tower.name, type: 'color', value: value
                    }));
                this.$message.success("投票成功");
                this.app.rating.colorrate[1] = data.rate.color;
                this.nowcolor = this.colorrate[1];
            } catch(e) {
                this.$message.error("投票失败");
            } finally {
                this.onDoColorRate = false;
            }
        }
    },
    components: {
        Rating, ARate,
        Title,
    },
}
</script>

<style lang="less" scoped>
.rating-board-content {
    text-align: left;
    margin-left: 10px;
}
.ratings {
    display: flex;
    margin-bottom: 10px;
}
.myrate-error {
    margin-bottom: 10px;
    color: rgba(0, 0, 0, 0.45);
}
.design-rating {
    border-right: 1px solid #dddddd;
}
.difficulty-rating {
    margin-left: 50px;
}
.difficulty-rate {
    font-size: 32px;
}
.rating-helper, .colorrate-helper {
    color: rgba(0, 0, 0, 0.45);
}
.qualification-check {
    list-style-type: none;
    padding-left: 10px;
    .success {
        color: #52c41a;
    }
    .error {
        color: #f5222d;
    }
    .passed {
        margin-left: 17px;
        color: rgba(0, 0, 0, 0.45);
    }
    .detail {
        margin-left: 25px;
    }
}
.colorrate-count {
    color: rgba(0, 0, 0, 0.45);
}
.colorrate-update, .colorrate-withdraw {
    margin-left: 10px;
}
</style>

<style lang="less">
blockquote {
    display: block;
    border-left: 8px solid #d0e5f2;
    padding: 5px 10px;
    margin: 10px 0;
    line-height: 1.4;
    font-size: 100%;
    background-color: #f1f1f1;
    p {
        margin: 10px 0;
        line-height: 1.5;
    }
}
</style>